// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".takeaways[data-v-7c1f9374]{padding:var(--unit-0600)}.takeaways__title[data-v-7c1f9374]{margin:0 0 var(--unit-0300)}.takeaways__list[data-v-7c1f9374]{display:flex;flex-direction:column;margin-bottom:0;padding-left:var(--unit-0600);grid-row-gap:var(--unit-0400);row-gap:var(--unit-0400)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
